import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import {strCode} from '../consts/strCode';
import log from '../services/logger/log';
import notificationService from '../services/notificationService';
import {selectIsNetworkNotificationsDisabled} from '../state/selectors/global';
import {setIsOnline} from '../state/slice/global';
import {getState} from '../state/store';

const useOfflineDetect = () => {
    const dispatch = useDispatch();

    const handleNetworkStatusChange = (isOnline) => {
        dispatch(setIsOnline(isOnline));

        log.debug(`useOfflineDetect: network status changed: ${isOnline ? 'online' : 'offline'}`);

        const isNetworkNotificationsDisabled = selectIsNetworkNotificationsDisabled(getState());

        if (isNetworkNotificationsDisabled) return;

        notificationService.showToastNotification({
            messageStr: isOnline ? strCode.GLOBAL_ONLINE_WARNING_MESSAGE : strCode.GLOBAL_OFFLINE_WARNING_MESSAGE,
        });
    };

    useEffect(() => {
        const handleOnline = () => {
            handleNetworkStatusChange(true);
        };

        const handleOffline = () => {
            handleNetworkStatusChange(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return null;
};

export default useOfflineDetect;
